import dayjs from 'dayjs'

/**获取时间戳 精确到秒 */
export function getTimestamp() {
  return Date.parse(new Date()) / 1000
}

export function getYestoday(format) {
  if (format) return dayjs().subtract(1, 'day').format(format)
  else return dayjs().subtract(1, 'day')
}

export function getToday(format) {
  if (format) return dayjs().format(format)
  else return dayjs()
}

export function getWeekRange(format) {
  if (format) return [dayjs().startOf('week').format(format), dayjs().format(format)]
  else return [dayjs().startOf('week'), dayjs()]
}

export function getlastWeekRange(format) {
  if (format) return [dayjs().startOf('week').subtract(7, 'day').format(format), dayjs().endOf('week').subtract(7, 'day').format(format)]
  else return [dayjs().startOf('week').subtract(7, 'day'), dayjs().endOf('week').subtract(7, 'day')]
}

export function getMonthRange(format) {
  if (format) return [dayjs().startOf('month').format(format), dayjs().format(format)]
  else return [dayjs().startOf('month'), dayjs()]
}

export function getlastMonthRange(format) {
  if (format) return [dayjs().subtract(1, 'month').startOf('month').format(format), dayjs().subtract(1, 'month').endOf('month').format(format)]
  else return [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]
}

export function getDateRanges(format) {
  return {
    今天: [getToday(format), getToday(format)],
    昨天: [getYestoday(format), getYestoday(format)],
    本周: getWeekRange(format),
    上周: getlastWeekRange(format),
    本月: getMonthRange(format),
    上月: getlastMonthRange(format)
  }
}
